export class InspectorOfficer1 {
    createdAt: Date;
    updatedAt: Date;
    createdBy: number;
    updatedBy: number;
    id: number;
    name: string;
    email: string;
    phone: string;
    type: string;
    designation: string;
    isActive: boolean;
    remarks?: any;
    size: number;
    page: number;
    sortingKey: string;
    sortingValue: string;
}
